export class ApiError extends Error {
  public source: unknown
  public extra: unknown

  constructor(source: unknown, message?: string, extra?: unknown) {
    super(getErrorMessage(source, message))
    this.source = source
    this.extra = extra
  }
}

function getErrorMessage(source: unknown, message?: string): string {
  return message ?? (source as Error)?.message ?? 'UnknownError'
}
